<template>
  <v-app>
    <Layout>
      <router-view />
    </Layout>
    <BaseNotification />
    <BaseOverlayLoading 
      v-if="overlay && overlay.status" 
      :message="overlay.message"/>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Layout from "@/layouts/Layout.vue";
import { STORE } from './enums/store';
import Vue from "vue";
import common from './common';
import { SNACKBAR } from './enums/snackbar';
export default {
  name: "App",
  data: () => ({}),
  components: {
    Layout,
    BaseNotification: () => import(/* webpackPrefetch: true */ "./components/BaseNotification.vue"),
    BaseOverlayLoading: () => import(/* webpackPrefetch: true */ "./components/BaseOverlayLoading.vue"),
  },
  created() {
    this.setAppBasicFunctions();
    this.$overlay.hide();
    this.$vuetify.theme.dark = localStorage.getItem('theme') ? (localStorage.getItem('theme')==='true') : false;
  },
  computed: {
    ...mapGetters(STORE.AUTH, ["authorized"]),
    ...mapState({
      overlay: state => state[STORE.APP].overlay_loading
    }),
    utils() {
      return {
        $route: this.$route,
        $router: this.$router,
        $store: this.$store,
      };
    }
  },
  methods: {
    setAppBasicFunctions() {
      // global utilities variable
      Vue.prototype.$utils = this.utils;

      // common snackbar methods
      Vue.prototype.$toast = {
        success: (message) => common.showNotification({ message, type: SNACKBAR.SUCCESS }, this.utils),
        error: (message) => common.showNotification({ message, type: SNACKBAR.ERROR }, this.utils),
        warning: (message) => common.showNotification({ message, type: SNACKBAR.WARNING }, this.utils),
      }

      // common overlay messages
      Vue.prototype.$overlay = {
        show: (message) => this.$store.commit(`${STORE.APP}/SET_OVERLAY_LOADING`, { status: true , message }),
        hide: () => this.$store.commit(`${STORE.APP}/SET_OVERLAY_LOADING`, { status: false , message: "" })
      }
    }
  }
};
</script>
<style lang="scss">
@font-face {
  font-family: baseFontBold;
  src: url(./assets/fonts/Sansation_Bold.ttf);
}
@font-face {
  font-family: baseFont;
  src: url(./assets/fonts/Sansation_Regular.ttf);
}
* {
  font-family: baseFontBold, sans-serif;
}

//font- overridings
.v-application [class*="text-"],
.v-application [class*="display-"],
.v-application [class*="subtitle-"],
.v-application .caption {
  font-family: baseFontBold, sans-serif !important;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: linear-gradient(315deg, #2e3192db 0%, #00aeef 74%);
}
.bg-app-background {
  background-color: $app-background-color;
}
.bg-app-base {
  background-color: $app-base-color;
}
.v-application {
  &.theme--dark{
    .border-base {
      background: $dark-background-overlay;
      backdrop-filter: blur(20px);
    }
    .dark-border {
      box-shadow: $app-border-shadow-dark;
    }
  }
  &:not(.theme--dark) {
    .border-base {
      background-color: $white;
      box-shadow: $app-border-shadow;
    }
  }
} 
.border-radius-lg {
  border-radius: $app-border-radius-lg;
}
.bb-light-grey{
  border-bottom: 1px solid lightgrey
}
.bt-light-grey{
  border-top: 1px solid lightgrey
}
.vertical-align-top {
  vertical-align: top;
}
.height-100 {
  height: 100%;
}
.width-100 {
  width: 100%;
}
.width-30 {
  width: 30%;
}
.width-17 {
  width: 17%;
}
.no-word-break {
  word-break: keep-all !important;
}
.nowrap {
  white-space: nowrap;
}
.break-spaces-pre {
  white-space: pre;
}
.relative {
  position: relative;
}
.capitalize {
  text-transform: capitalize;
}
.cursor-pointer,
.cursor-pointer .v-text-field > .v-input__control > .v-input__slot {
  cursor: pointer !important;
}
.rm-col-y-padding .col-12{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.label {
  opacity: 0.85;
  font-size: 0.80rem;
  position: relative;
  &.required::after {
    content: "*";
    color: red;
    font-size: 24px;
    padding-left: 3px;
    position: absolute;
  }
}
.v-btn.primary:not(.v-btn--round) {
  background-image: $app-base-gradient !important;
}
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: $app-base-light-color !important;
}
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.completed:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.completed {
  background: $success-background !important;
}
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.notified:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.notified {
  background: $notified-background !important;
  .v-application.theme--dark & {
    background: rgba(250, 217, 174, 0.25) !important;
  }
}
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.edited:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.edited {
  background: $app-base-medium-color !important;
}
.base_stepper {
  .v-stepper__header {
    position: fixed;
    z-index: 10;
    background: inherit;
    width: 77vw;
    &.sm {
      width: 85vw;
    }
  }
  .v-stepper__items {
    padding-top: 45px;
  }
}
@media (max-width: 420px) {
  .base_stepper {
    .v-stepper__step {
      padding: 10px 16px !important;
    }
  }
}
.v-stepper__header {
  box-shadow: none !important;
  height: auto !important;
}
.v-stepper__step{
  padding: 10px 24px !important;
  &--active {
    background: $app-base-light-color !important;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width:100%;
      height: 4px;
      background-color: $app-base-color;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
}
.v-stepper .v-stepper__step--editable:hover {
  background: $app-base-light-color !important;
}

@media screen and (min-width: 960px) {
  .height-100-mdup {
    height: 100%;
  }
}
.v-sheet.v-card.border-base {
  background-color: $white !important;
  box-shadow: $app-border-shadow !important;
}

.v-application .primary-gradient {
  background-image: $app-base-gradient !important;
}
//overriding base css

/* Ensure menus appear above table content */
.v-menu__content {
  z-index: 2000 !important;
}

.v-menu__content--fixed {
  z-index: 2000 !important;
}

/* Dark mode support for BaseDateTimePicker time picker */
.v-application.theme--dark .time-container {
  background: $dark-background !important;
}

.v-application.theme--dark .time-container .v-label,
.v-application.theme--dark .time-container .v-select__selection,
.v-application.theme--dark .time-container .v-input__control,
.v-application.theme--dark .time-container .v-select .v-input__slot,
.v-application.theme--dark .time-container .v-select .v-input__append-inner,
.v-application.theme--dark .time-container .v-select .v-input__slot::before,
.v-application.theme--dark .time-container .v-select .v-input__slot::after {
  color: $dark-text !important;
  border-color: $dark-border-light !important;
}

.action-column {
  position: sticky;
  right: 0;
  top: 0;
  background: $white;
  z-index: 20;
  width: 120px;
  border-left: 1px solid $light-border;
}

.v-application.theme--dark .action-column {
  background: $dark-background;
  border-left: 1px solid $dark-border-light;
}

.data-cell-nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 110px;
}

.sticky-header {
  position: sticky;
  top: 0;
  background: $white;
  z-index: 30;
}

.v-application.theme--dark .sticky-header {
  background: $dark-background;
}

.action-column-header {
  position: sticky;
  right: 0;
  top: 0;
  background: $white;
  z-index: 40;
  width: 120px;
  border-left: 1px solid $light-border;
}

.v-application.theme--dark .action-column-header {
  background: $dark-background;
  border-left: 1px solid $dark-border-light;
}

// Action column icons - let Vuetify's inline color take precedence
.base-data-table td.action-column .v-icon,
.base-data-table td.action-column-header .v-icon {
  opacity: 1;
}

// Dark mode - Action column icons should keep their original colors
.v-application.theme--dark .base-data-table td.action-column .v-icon,
.v-application.theme--dark .base-data-table td.action-column-header .v-icon {
  opacity: 1;
}

.base-data-table {
  tbody td {
    border-bottom: thin solid $light-border-row !important;
  }
}

/* Dark mode - Header filter textboxes (exclude readonly inputs) */
.v-application.theme--dark .base-data-table input:not([readonly]) {
  color: $dark-text !important;
  border: 1px solid $dark-border !important;
}

/* Date filter readonly textbox */
.v-application.theme--dark .base-data-table input[readonly] {
  background: $dark-surface !important;
  color: $dark-text !important;
  border: none !important;
}

// Dark mode icons for pagination arrows and table icons only
.v-application.theme--dark .base-data-table .footer-group-wrapper .v-icon {
  color: $dark-text !important;
}

.v-application.theme--dark .base-data-table .sticky-header-th .v-icon {
  color: $dark-text !important;
}

/* Dark mode - Date filter popup card (menu content is teleported outside .base-data-table) */
.v-application.theme--dark .date-filter-container .v-card,
.v-application.theme--dark .date-filter-content .v-card {
  background-color: $dark-surface !important;
}

/* Dark mode - Date filter type select inside filter menu */
.v-application.theme--dark .date-filter-container .v-select,
.v-application.theme--dark .date-filter-content .v-select {
  .v-select__selection {
    color: $dark-text !important;
  }
  .v-input__slot {
    background: transparent !important;
  }
  &.v-input--is-outlined fieldset {
    border-color: $dark-border !important;
  }
}

/* Dark mode - Date filter input fields inside popup (menu content is teleported) */
.v-application.theme--dark .date-filter-container input[type="text"],
.v-application.theme--dark .date-filter-content input[type="text"] {
  color: $dark-text !important;
  background: $dark-surface !important;
  border: 1px solid $dark-border !important;
}

/* Dark mode - Information popup cards - background and text */
.v-application.theme--dark .v-menu__content .v-card {
  background-color: $dark-surface !important;
  .v-card__text,
  .v-card-text,
  .text-caption,
  .location-mini td,
  .supplier-mini td,
  .customer-mini-table td {
    color: $dark-text !important;
  }
}

/* Dark mode - Footer selects (items per page, go to page) - hide the outline border */
.v-application.theme--dark .base-data-table .footer-group-wrapper .v-select {
  .v-input__slot {
    background: transparent !important;
    box-shadow: none !important;
  }
  &.v-input--is-outlined fieldset {
    border-color: transparent !important;
  }
  .v-select__selection {
    color: $dark-text !important;
  }
}
.trim-text .v-select__selection{
  max-width: 170px;
}
</style>
<style lang="scss">
// For AG Grid
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";
.ag-table {
  width: 100%;
  &.ag-theme-alpine {
    .ag-header {
      background-color: $white !important;
    }
    .ag-root-wrapper.ag-layout-normal {
      background-color: $white !important;
      box-shadow: $app-border-shadow !important;
      border: none !important;
    }
  }
}
</style>